import { createSelector } from 'reselect';

export const getStatusesAccesor = state => state.tickets.statuses;

export const statusesSelector = createSelector(getStatusesAccesor, statuses => statuses);
